import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersubfull } from "../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { TableDanhSachKiemKho } from "./TableDanhSachKiemKho";
import { BtnXuatDanhSach } from "components/DanhSachKiemKho/ChucNang/XuatDanhSach/BtnXuatDanhSach";
import { BtnInDanhSach } from "components/DanhSachKiemKho/ChucNang/InDanhSach/BtnInDanhSach";
import DanhSachKiemKhoApi from "../../service/danhSachKiemKhoApi";
import LayoutV2 from "containers/LayoutV2";
export const DanhSachKiemKho = () => {
  //phân quyền
  const initQuyenDanhSach = {
    danhsachkiemkho_danhsach: false,
    danhsachkiemkho_inchitiet: false,
    danhsachkiemkho_indanhsach: false,
    danhsachkiemkho_xemchitiet: false,
    danhsachkiemkho_xuatexceldanhsach: false,
  };

  const [quyenDanhSach, setQuyenDanhSach] = useState(initQuyenDanhSach);
  const LayQuyenQuanLyDanhSach = () => {
    DanhSachKiemKhoApi.phanquyenDsKiemKho().then((response) => {
      // console.log(response.data);
      setQuyenDanhSach({
        ...quyenDanhSach,
        danhsachkiemkho_danhsach:
          response.data.danhsachkiemkho_danhsach === null ||
          response.data.danhsachkiemkho_danhsach === undefined
            ? false
            : response.data.danhsachkiemkho_danhsach,
        danhsachkiemkho_xemchitiet:
          response.data.danhsachkiemkho_xemchitiet === null ||
          response.data.danhsachkiemkho_xemchitiet === undefined
            ? false
            : response.data.danhsachkiemkho_xemchitiet,
        danhsachkiemkho_inchitiet:
          response.data.danhsachkiemkho_inchitiet === null ||
          response.data.danhsachkiemkho_inchitiet === undefined
            ? false
            : response.data.danhsachkiemkho_inchitiet,
        danhsachkiemkho_indanhsach:
          response.data.danhsachkiemkho_indanhsach === null ||
          response.data.danhsachkiemkho_indanhsach === undefined
            ? false
            : response.data.danhsachkiemkho_indanhsach,
        danhsachkiemkho_xuatexceldanhsach:
          response.data.danhsachkiemkho_xuatexceldanhsach === null ||
          response.data.danhsachkiemkho_xuatexceldanhsach === undefined
            ? false
            : response.data.danhsachkiemkho_xuatexceldanhsach,
      });
      console.log(response.data.danhsachkiemkho_xuatexceldanhsach);
      console.log(quyenDanhSach);
    });
  };

  useEffect(() => {
    LayQuyenQuanLyDanhSach();
  }, []);

  return (
    <LayoutV2>
      {quyenDanhSach.danhsachkiemkho_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Danh sách kiểm kho
                          </h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              {quyenDanhSach.danhsachkiemkho_indanhsach && (
                                <BtnInDanhSach />
                              )}
                            </li>
                            <li>
                              {quyenDanhSach.danhsachkiemkho_xuatexceldanhsach && (
                                <BtnXuatDanhSach />
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                 <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSachKiemKho
            quyenXemChiTiet={quyenDanhSach.danhsachkiemkho_xemchitiet}
            quyenInChiTiet={quyenDanhSach.danhsachkiemkho_inchitiet}
          />
        </div>
      )}
      {quyenDanhSach.danhsachkiemkho_danhsach === false && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Danh sách kiểm kho"
                      icon1="mdi mdi-warehouse"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
